class Request {
    static ALLOWED_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'OPTIONS', 'DELETE'];

    json = true;

    constructor(path, method = 'GET') {
        this.path = path;
        this.method = method;
        this.credentials = false;
    }

    set base(url) {
        this._base = url;
    }

    /**
     * Get the full request url
     * @returns {String}
     */
    get url() {
        return this._base + this.path;
    }

    /**
     * Set the request method
     * @param m {String}
     */
    set method(m) {
        if (Request.ALLOWED_METHODS.indexOf(m.toUpperCase()) === -1) {
            throw new Error('Method ' + m + ' is not allowed.');
        }

        this._method = m.toUpperCase();
    }

    /**
     * Get the request method
     * @returns {String}
     */
    get method() {
        return this._method;
    }

    /**
     * Set the headers object
     * @param headers {{}}
     */
    set headers(headers) {
        if (headers.constructor !== Object) {
            throw new Error(
                'Request headers expected an object with key value pairs for each header and its value.',
            );
        }

        this._headers = headers;
    }

    /**
     * Get the headers object
     * @returns {{}}
     */
    get headers() {
        if (this._headers === undefined || this._headers === null) {
            this._headers = {};
        }

        return this._headers;
    }

    /**
     * Add an extra header field
     * @param key {String}
     * @param value {String}
     */
    addHeader(key, value) {
        this.headers[key] = value;
    }

    /**
     * Add a set of headers to the request and merge them with any existing headers
     * @param toAdd {{}}
     */
    addHeaders(toAdd) {
        if (toAdd.constructor !== Object) {
            throw new Error(
                'Request headers expected an object with key value pairs for each header and its value.',
            );
        }

        this.headers = Object.assign({}, this.headers, toAdd);
    }

    /**
     * Set the authorization token in the header field.
     * @param token {String}
     */
    set auth(token) {
        if (token !== null && token !== undefined) {
            this.headers['Authorization'] = 'Bearer ' + token;
        } else {
            delete this.headers['Authorization'];
        }
    }

    set body(body) {
        this._body = body;
    }

    get body() {
        return this._body;
    }

    withCredentials() {
        this.credentials = true;
        return this;
    }

    _createConfigObject() {
        let config = {
            method: this.method,
            headers: this.headers,
        };

        if (this.body !== undefined && this.body !== null) {
            config.body = this.body;
        }

        if (this.credentials) {
            config.credentials = 'include';
        }

        return config;
    }

    set vueRouter(router) {
        this._vueRouter = router;
    }

    get vueRouter() {
        return this._vueRouter;
    }

    send(body) {
        let config = this._createConfigObject();

        if (body !== undefined) {
            config.body = body;
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, config)
                .then(response => {
                    if (!response.ok) {
                        // Failure
                        // eslint-disable-next-line no-undef
                        if (
                            response.status === 403 ||
                            (response.status === 401 && process.env.NODE_ENV === 'production')
                        ) {
                            if (
                                this.vueRouter &&
                                this.vueRouter.currentRoute.meta &&
                                this.vueRouter.currentRoute.meta.auth !== false
                            )
                                this.vueRouter.push({ name: 'Login' });
                            reject(response);
                        }

                        reject(response);
                    } else {
                        // Success
                        if (this.method !== 'DELETE' && this.json) {
                            response.json().then(json => {
                                resolve(json);
                            });
                        } else {
                            resolve(response);
                        }
                    }
                })
                .catch(err => {
                    // Error
                    throw new Error(err);
                });
        });
    }
}

export default Request;
